module.exports = __webpack_public_path__ + "img/shenzhen_door.5dbfae6b.jpg";